import { fieldEntryHasPresentableValue } from '@/common/utils/changedDataFieldMerge'
import { resolvePageFieldEntry } from '@/common/utils/pageFieldRegistryWrite'
import { coerceStateBoolean } from '@/common/utils/resolveActionPageState'
import { unwrapScriptValue } from '@/common/utils/wrapScriptValue'

export function readBooleanFromFieldEntry(entry: unknown): boolean | null {
  if (entry === undefined) return null
  if (!fieldEntryHasPresentableValue(entry)) return null

  const raw =
    entry && typeof entry === 'object' && !Array.isArray(entry) && 'value' in entry
      ? unwrapScriptValue((entry as { value: unknown }).value)
      : unwrapScriptValue(entry)

  return coerceStateBoolean(raw) ?? null
}

export function resolveBooleanFieldValueFromPageFields(
  pageFields: Record<string, unknown> | undefined,
  fieldName: string,
): boolean | null {
  const entry = resolvePageFieldEntry(pageFields ?? {}, fieldName)
  if (entry === undefined) return null
  return readBooleanFromFieldEntry(entry)
}
